<template>
    <v-app>
        <v-snackbar
            v-model="show_message"
            :timeout="timeout"
            top dark
            color="red darken-2"
            class="font-weight-black"
        >
            {{ message }}
            <v-btn
                text dark
                @click="show_message = false"
            >
                Fechar
            </v-btn>
        </v-snackbar>

        <v-card width="350" class="xs-8 sm-8 md-4 mx-auto mt-5">
            <v-card-title>
                <h1 class="display-1">Login</h1>
            </v-card-title>
            <v-card-text>
                <v-form ref="loginForm">
                <v-text-field label="Username"
                    v-model="email"
                    type="email"
                    prepend-icon="fa-user-circle"
                    autofocus
                    :rules="inputRules"
                />
                <v-text-field label="Password"
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    prepend-icon="fa-key"
                    :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                    @click:append="showPassword = !showPassword"
                    v-on:keyup.enter="login"
                    :rules="inputRules"
                />
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center">       
                <v-btn color="info" @click="login">Login</v-btn>
            </v-card-actions>
        </v-card>
    </v-app>
</template>

<script>
import { auth } from '@/plugins/firebase'

export default {
    name: 'Login',

    components: {
    },
    data: () => ({
        showPassword: false,
        email: '',
        password: '',
        show_message: false,
        message: "Erro: Informações Inválidas ou Usuário Inexistente",
        timeout: 3000,
        inputRules: [
            v => v.length > 5 || 'O tamanho mínimo é de 5 caracteres'
        ],
    }),
    computed: {
    },
    methods: {
        async login () {
            if (this.$refs.loginForm.validate()) {
                try {
                    this.$store.dispatch('SHOW_GLOBAL_PROGRESS_DIALOG', 'Autenticando')
                    auth.signInWithEmailAndPassword(this.email, this.password)
                        .then( () => {
                            this.$store.dispatch('AUTH_USER', auth.currentUser)
                            this.$router.replace({name: 'Home'})
                            this.$store.dispatch('HIDE_GLOBAL_PROGRESS_DIALOG')
                        })
                        .catch(err => {
                            console.error('Login Error', err)
                            this.message = err
                            this.show_message = true
                            this.$store.dispatch('AUTH_USER', null)
                            this.$store.dispatch('HIDE_GLOBAL_PROGRESS_DIALOG')
                        })
                } catch (error) {
                    console.error('try login', error)
                    this.$store.dispatch('HIDE_GLOBAL_PROGRESS_DIALOG')
                }
            }
        },
    }
};
</script>
